import { createSportsAccountTransport } from './sportsAccountTransport';
import { captureSportsnewAccountCarrier, isSportsnewAccountCarrierCurrent, sportsnewLocalRequestRejection } from './sportsnewAccountCarrier';

// Read-only sports port. Shared WalletContext applies to Auth before resolving,
// so it cannot own these account-fenced reads. This module never writes state.
export const createSportsWalletReader = () => {
  const transport = createSportsAccountTransport();
  const pending = new WeakMap();
  const read = ({ accountGuard, isCurrent } = {}) => {
    const carrier = captureSportsnewAccountCarrier({ accountGuard, isCurrent });
    if (!isSportsnewAccountCarrierCurrent(carrier)) return Promise.reject(sportsnewLocalRequestRejection());
    const previous = pending.get(accountGuard);
    if (previous && isSportsnewAccountCarrierCurrent(previous.carrier)) return previous.promise;
    const entry = { carrier };
    entry.promise = transport.request('/member/wallet-summary', { method: 'GET' }, carrier).then(response => {
      if (!isSportsnewAccountCarrierCurrent(carrier)) throw sportsnewLocalRequestRejection();
      const payload = response?.data;
      if (response?.status === 0 || payload?.success === false || payload?.status === false) {
        throw new Error('Sports wallet balance unavailable');
      }
      return payload?.data || payload;
    }).finally(() => {
      if (pending.get(accountGuard) === entry) pending.delete(accountGuard);
    });
    pending.set(accountGuard, entry);
    return entry.promise;
  };
  return { read, client: transport.client };
};
const sportsWalletReader = createSportsWalletReader();
export const readSportsWalletSummary = sportsWalletReader.read;
